module.exports = __webpack_public_path__ + "static/hero-bb02aff9425f5f87accdb5369d14326e.jpg";